<template>
    <div class="tuike">
        <header1></header1>
        <div class="main-tuike">
            <div class="nav-bg">
                <div class="nav-banner">
                    <div class="banner-box">
                        <div class="left">
                            <div class="title">推客裂变营销工具</div>
                            <div class="title">全民合伙人 人人是推客</div>
                            <p class="sub-title">
                                社会化网络时代、每个人都是媒体，每个人都是传播源。以传播业绩可追踪、权益激励到人为驱动力，对活动侧加以灵活运营配置支撑，发挥裂变营销的强大效能。
                            </p>
                            <div>
                                <a @click="denglu" class="btn">立即试用</a>
                            </div>
                        </div>
                        <div class="nav-bars">
                            <div class="bar">
                                <img
                                    src="https://ccbhdimg.kerlala.com/hd/website/urthink/tuike/icon_1.png"
                                    alt=""
                                />
                                <div>
                                    <div class="txt">联合营销</div>
                                    <div class="txt">效果翻倍</div>
                                </div>
                            </div>
                            <div class="bar">
                                <img
                                    src="https://ccbhdimg.kerlala.com/hd/website/urthink/tuike/icon_2.png"
                                    alt=""
                                />
                                <div>
                                    <div class="txt">提升员工</div>
                                    <div class="txt">传播驱动力</div>
                                </div>
                            </div>
                            <div class="bar">
                                <img
                                    src="https://ccbhdimg.kerlala.com/hd/website/urthink/tuike/icon_3.png"
                                    alt=""
                                />
                                <div>
                                    <div class="txt">员工/渠道</div>
                                    <div class="txt">业绩牢牢掌握</div>
                                </div>
                            </div>
                            <div class="bar">
                                <img
                                    src="https://ccbhdimg.kerlala.com/hd/website/urthink/tuike/icon_4.png"
                                    alt=""
                                />
                                <div>
                                    <div class="txt">降低营销</div>
                                    <div class="txt">资源成本</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="dom-wrap mt163">
                <div class="dom-item">
                    <div class="dom-title">裂变营销的痛点</div>
                    <div class="dom-content flex">
                        <img
                            src="https://ccbhdimg.kerlala.com/hd/website/urthink/tuike/img_1.png"
                            alt=""
                        />
                        <div class="dom-txt">
                            <div class="txt">
                                渠道分润<span class="bold">难管理</span>
                            </div>
                            <div class="txt">
                                传播链路<span class="bold">难以追踪</span>
                            </div>
                            <div class="txt">
                                获客<span class="bold">渠道少</span>
                            </div>
                            <div class="txt">
                                推广奖励<span class="bold">单一缺少吸引力</span>
                            </div>
                            <div class="txt">
                                员工推广<span class="bold">积极性缺乏</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="dom-wrap dom-type-1">
                <div class="dom-item">
                    <div class="dom-title">我们的解决方案</div>
                    <div class="boxes">
                        <div class="box">
                            <div class="num-info">
                                <span class="num">01</span
                                ><span class="arr"></span>
                            </div>
                            <div class="txt">裂变任务</div>
                            <div class="txt">便捷发布统一管理</div>
                        </div>
                        <div class="box">
                            <div class="num-info">
                                <span class="num">02</span
                                ><span class="arr"></span>
                            </div>
                            <div class="txt">多渠道多层级</div>
                            <div class="txt">利润分配</div>
                        </div>
                        <div class="box">
                            <div class="num-info">
                                <span class="num">03</span
                                ><span class="arr"></span>
                            </div>
                            <div class="txt">权益出入库</div>
                            <div class="txt">发放审批管控</div>
                        </div>
                        <div class="box">
                            <div class="num-info">
                                <span class="num">04</span
                                ><span class="arr"></span>
                            </div>
                            <div class="txt">传播全链路</div>
                            <div class="txt">数据跟踪</div>
                        </div>
                        <div class="box">
                            <div class="num-info">
                                <span class="num">05</span
                                ><span class="arr"></span>
                            </div>
                            <div class="txt">积分兑换商城</div>
                            <div class="txt">奖励种类丰富</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="dom-wrap dom-type-2">
                <div class="dom-item">
                    <div class="img-txt">
                        <img
                            src="https://ccbhdimg.kerlala.com/hd/website/urthink/tuike/img_2.png"
                            alt=""
                        />
                        <div class="desc">
                            <div class="intro">
                                营销活动、产品宣传均可作为任务进行发布,
                                发布方式操作简洁，用户可浏览平台中的任务,
                                生成自己的专属海报, 或直接分享链接,
                                转发传播营销活动。
                            </div>
                            <div class="intro-title">种子用户任务裂变</div>
                            <div class="intro-content">
                                <div class="intro-item-box">
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt"
                                            >快速创建裂变任务</span
                                        >
                                    </div>
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt"
                                            >多元渠道推广</span
                                        >
                                    </div>
                                </div>
                                <div class="intro-item-box">
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt"
                                            >分享海报/分享链接</span
                                        >
                                    </div>
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt"
                                            >分享方式多样</span
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="img-txt flex-reverse">
                        <img
                            src="https://ccbhdimg.kerlala.com/hd/website/urthink/tuike/img_3.png"
                            alt=""
                        />
                        <div class="desc">
                            <div class="intro">
                                传播内容多种多样,
                                邀新办业务、营销活动、基金产品、理财产品、信贷产品、品牌宣传等,
                                均可以作为裂变传播的内容, 在平台中上传维护.
                                用户可按需, 选择适合的传播内容进行转发.
                                理财、基金等产品类内容,支持系统对接实时读取产品数据,
                                保障转发内容的准确性。
                            </div>
                            <div class="intro-title">裂变传播内容多样</div>
                            <div class="intro-content">
                                <div class="intro-item-box">
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt"
                                            >邀新开户 邀新开卡</span
                                        >
                                    </div>
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt"
                                            >营销活动推广</span
                                        >
                                    </div>
                                </div>
                                <div class="intro-item-box">
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt"
                                            >信贷产品推广</span
                                        >
                                    </div>
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt"
                                            >理财产品、基金产品推广</span
                                        >
                                    </div>
                                </div>
                                <div class="intro-item-box">
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt">品牌宣传</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="img-txt">
                        <img
                            src="https://ccbhdimg.kerlala.com/hd/website/urthink/tuike/img_4.png"
                            alt=""
                        />
                        <div class="desc">
                            <div class="intro">
                                系统可收集所有员工（总行、分行、支行各个层级）、忠实用户、第三方机构的线上线下场景传播数据，可记录任务每个节点的进度情况,
                                好友的达标情况,
                                支持进行科学有效的绩效分配、福利发放。
                                将所有场景触点都变成智能的传播源，有效提升场景运营的整体效率.
                            </div>
                            <div class="intro-title">
                                邀请链路、任务进度全程跟踪
                            </div>
                            <div class="intro-content">
                                <div class="intro-item-box">
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt"
                                            >裂变邀请数据记录</span
                                        >
                                    </div>
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt"
                                            >任务进度记录</span
                                        >
                                    </div>
                                </div>
                                <div class="intro-item-box">
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt"
                                            >达标进度记录</span
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="img-txt flex-reverse">
                        <img
                            src="https://ccbhdimg.kerlala.com/hd/website/urthink/tuike/img_5.png"
                            alt=""
                        />
                        <div class="desc">
                            <div class="intro">
                                系统支持不同维度的业绩数据排行,
                                例如员工维度、分支行、网点维度等,
                                可按分享、浏览、达标等数据进行排行,
                                为运营工作提供业绩评判标准, 完成情况一目了然。
                            </div>
                            <div class="intro-title">支行网点推广业绩排行</div>
                            <div class="intro-content">
                                <div class="intro-item-box">
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt"
                                            >推广业绩统计</span
                                        >
                                    </div>
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt"
                                            >分支行排行</span
                                        >
                                    </div>
                                </div>
                                <div class="intro-item-box">
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt">员工排行</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="img-txt">
                        <img
                            src="https://ccbhdimg.kerlala.com/hd/website/urthink/tuike/img_6.png"
                            alt=""
                        />
                        <div class="desc">
                            <div class="intro">
                                系统提供的积分兑换商城,
                                可与手机银行APP、小程序、微信公众号等其他线上资源整合，为用户提供统一的积分兑换平台,
                                以丰富的奖励吸引用户, 增加用户回流场景。
                                积分、权益的出入库、核销等均可统一管理. 同时,
                                可支持对接第三方权益供应商。
                            </div>
                            <div class="intro-title">积分兑换商城</div>
                            <div class="intro-content">
                                <div class="intro-item-box">
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt"
                                            >积分管理/积分统计</span
                                        >
                                    </div>
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt"
                                            >权益管理/出入库/分配</span
                                        >
                                    </div>
                                </div>
                                <div class="intro-item-box">
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt"
                                            >积分商城/权益兑换</span
                                        >
                                    </div>
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt"
                                            >卡券/话费/实物等</span
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="dom-wrap dom-type-3">
                <div class="dom-item">
                    <div class="dom-title">推客裂变合作案例</div>
                    <div class="hb-box-h">
                        <div>
                            <span class="gou"></span
                            ><span class="gou-txt"
                                >裂变平台开展活动超千余场</span
                            >
                        </div>
                        <div>
                            <span class="gou"></span
                            ><span class="gou-txt">累计百万有效推荐人</span>
                        </div>
                    </div>
                    <div class="hb-box-b">
                        <img
                            src="https://ccbhdimg.kerlala.com/hd/website/urthink/tuike/img_9.png"
                            alt=""
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="bottom">
            <more :moreid="id"></more>
            <info></info>
        </div>
    </div>
</template>

<script>
import header1 from "../../components/header1.vue";
import more from "../../components/more.vue";
import info from "../../components/info.vue";
export default {
    data() {
        return {
            tabs: [
                { name: "中国建设银行", active_no: true },
                { name: "中信银行", active_no: false },
                { name: "厦门银行", active_no: false },
                { name: "郑州银行", active_no: false },
            ],
            id: 3
        };
    },
    components: { header1, more, info },
    mounted() {
        var that = this;
        // this.common.mounted(that);
    },
    computed: {},
    methods: {
        nolond() {},
        onChange(index) {
            var tab = this.tabs;
            tab.forEach((item, val) => {
                if (index == val) {
                    item.active_no = true;
                } else {
                    item.active_no = false;
                }
            });
        },
        swipw_prev() {
            this.$refs.mySwiper.prev();
        },
        swipw_next() {
            // swipeTo
            this.$refs.mySwiper.next();
        },
        activeTabs(index) {
            var tab = this.tabs;
            tab.forEach((item, val) => {
                if (index == val) {
                    item.active_no = true;
                } else {
                    item.active_no = false;
                }
            });

            this.$refs.mySwiper.swipeTo(index);
        },
         denglu() {
            this.$router.push({
                path: "/login",
            });
        },
    },
};
</script>
<style scoped>
@import "../../../static/chunk-pmr.css";
</style>


// WEBPACK FOOTER //
// src/views/slg/pmr.vue